<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>产品来源</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">手机号码</label>
                    <el-input v-model.trim="query.phone" placeholder="来源名称" class="handle-input mr10"></el-input>
                </span>
                <span class="label-span">
                    <label class="label">省份</label> 
                    <el-input v-model.trim="query.province" placeholder="省份" class="handle-input mr10"></el-input> 
                </span>   
                <span class="label-span">
                    <label class="label">地市</label> 
                    <el-input v-model.trim="query.city" placeholder="地市" class="handle-input mr10"></el-input> 
                </span>   
                <span class="label-span">
                    <label class="label">运营商</label> 
                    <el-select v-model.trim="query.isp" placeholder="请选择" class="handle-input mr10"  > 
                        <el-option label="移动" value="1" />
                        <el-option label="联通" value="2" />
                        <el-option label="电信" value="3" />    
                    </el-select>  
                </span>   
                <el-button type="success" icon="el-icon-search" class='mr10' @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class='mr10' @click="refreshSearch">重置</el-button>
              <el-dropdown class='mr10'>
                  <el-button  type="primary" >批量操作</el-button>
                  <el-dropdown-menu slot="dropdown">
                        <span class='tableOperBtn2' @click="updateCity">
                            地市变更
                        </span>
                  </el-dropdown-menu>
              </el-dropdown>


                <el-button  type="primary" @click="addBind" >新增号段</el-button>

               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="phone3" min-width="110" align="left" label="号码前三位"> </el-table-column>     
                <el-table-column prop="phone7" min-width="110" align="left" label="号码前七位"> </el-table-column>     
                <el-table-column prop="isp" min-width="80" align="center" label="运营商">
                    <template slot-scope="scope"> 
                        {{scope.row.isp==1?'移动':scope.row.isp==2?'联通':scope.row.isp==3?'电信':'其它'}}
                    </template>
                </el-table-column>     
                <el-table-column prop="province" min-width="110" align="left" label="省份"> </el-table-column>     
                <el-table-column prop="city" min-width="110" align="left" label="地市"> </el-table-column>     
                <el-table-column prop="code" min-width="100" align="left" label="行政编码"> </el-table-column>       
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增号段" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="100px"  @submit.native.prevent="saveForm">
                <el-form-item required label="号码前三位">
                    <el-input v-model.trim="form1.phone3"  placeholder="号码前三位" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item required label="号码前七位">
                    <el-input v-model.trim="form1.phone7"  placeholder="号码前七位" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item required label="运营商">
                   <el-radio-group  v-model.trim="form1.isp" >
                        <el-radio-button label="1">移动</el-radio-button> 
                        <el-radio-button label="2">联通</el-radio-button>
                        <el-radio-button label="3">电信</el-radio-button> 
                    </el-radio-group> 
                </el-form-item>   
                <el-form-item required label="省份">
                    <el-input v-model.trim="form1.province"  placeholder="省份（不含省字）" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item required label="地市">
                    <el-input v-model.trim="form1.city"  placeholder="地市（不含市字）" style="width:360px;"></el-input>
                </el-form-item>     
                <el-form-item label="行政编码">
                    <el-input v-model.trim="form1.code"  placeholder="行政编码" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑号段" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="100px">
                <el-form-item required label="号码前三位">
                    <el-input v-model.trim="form2.phone3"  placeholder="号码前三位" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item required label="号码前七位">
                    <el-input v-model.trim="form2.phone7"  placeholder="号码前七位" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item required label="运营商">
                   <el-radio-group  v-model.trim="form2.isp" >
                        <el-radio-button label="1">移动</el-radio-button> 
                        <el-radio-button label="2">联通</el-radio-button>
                        <el-radio-button label="3">电信</el-radio-button> 
                    </el-radio-group> 
                </el-form-item>   
                <el-form-item required label="省份">
                    <el-input v-model.trim="form2.province"  placeholder="省份" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item required label="地市">
                    <el-input v-model.trim="form2.city"  placeholder="地市" style="width:360px;"></el-input>
                </el-form-item>     
                <el-form-item label="行政编码">
                    <el-input v-model.trim="form2.code"  placeholder="行政编码" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="批量修改地市" :visible.sync="editVisible2" :modal-append-to-body='false' top="50px" width="360px">
            <el-form ref="form3" :model="form3" label-width="90px">
                <el-form-item label="原地市名称">
                    <p>{{query.city}}</p>
                </el-form-item>
                <el-form-item required label=" 修改为：">
                    <el-input v-model.trim="form3.newCity"  placeholder="地市" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit2">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,updateCity,changeStatus,fetchDataDir} from '../../api/comPhoneArea';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editVisible2: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
            },
            form2: {   },
            form3: { city:'',newCity:'',  },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'province');
            this.$set(this.query, 'city');
            this.$set(this.query, 'isp');
            this.$set(this.query, 'phone');
            this.getData();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                }
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
       

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        updateCity(){
            if(!this.query.city){
                this.$message.error("请填写地市后搜索");
                return;
            }
            if(this.pageTotal>1000){
                this.$message.error("请搜索后再进行变更");
                return;
            }
            this.form3.newCity = '';
            this.editVisible2 = true;
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.phone3 ){
                this.isSubmitting = false;
                this.$message.error("请填写号码前3位");
                return;
            }
            if( !this.form1.phone7 ){
                this.isSubmitting = false;
                this.$message.error("请填写号码前7位");
                return;
            }
            if( this.form1.phone7.length!=7 ){
                this.isSubmitting = false;
                this.$message.error("号码前7位位数不正确");
                return;
            }
            if( !this.form1.province ){
                this.isSubmitting = false;
                this.$message.error("请填写省份");
                return;
            }
            if( !this.form1.city ){
                this.isSubmitting = false;
                this.$message.error("请填写地市");
                return;
            }if( !this.form1.isp ){
                this.isSubmitting = false;
                this.$message.error("请选择运营商");
                return;
            }
            this.loading = true; 
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                    this.$message.success(res.message); 
                } else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                }
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        saveEdit2() {
            this.editVisible2 = false;
            let data = {};
            data.city = this.query.city;
            data.newCity = this.form3.newCity;
            updateCity(data).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message);
                    this.getData();
                }else{
                    this.editVisible2 = true;
                    this.$message.error(res.message);
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid; 
            // 二次确认删除
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
